module.exports = __webpack_public_path__ + "e47c93c818c16cb17b6ce6ebc8029da2.svg";